
// Initialize Slick Slider
document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.cstm-tab').forEach(tab => {
    
    tab.addEventListener('click', function() {
      document.querySelectorAll('.cstm-tab').forEach(t => t.classList.remove('active'));
      document.querySelectorAll('.cstm-tab-content, .cstm-tab-content-1, .cstm-tab-content-2').forEach(content => content.classList.remove('active'));
      this.classList.add('active');
      document.querySelector(`[data-content="${this.dataset.tab}"]`).classList.add('active');
      $('.cstm-tab-content').slick('refresh');
      $('.cstm-tab-content-1').slick('refresh');
      $('.cstm-tab-content-2').slick('refresh');

    });
  });

  const sliders = document.querySelectorAll('.slider');
  sliders.forEach(slider => {
    const sliderInner = slider.querySelector('.slider-inner');
    const leftBtn = slider.querySelector('.slider-control.left');
    const rightBtn = slider.querySelector('.slider-control.right');

    // Initialize slick slider on .cstm-tab-content
    $('.cstm-tab-content').slick({
      prevArrow: leftBtn,
      nextArrow: rightBtn,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });

    // Initialize slick slider on .cstm-tab-content-1
    $('.cstm-tab-content-1').slick({
      prevArrow: leftBtn,
      nextArrow: rightBtn,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });

    // Initialize slick slider on .cstm-tab-content-2
    $('.cstm-tab-content-2').slick({
      prevArrow: leftBtn,
      nextArrow: rightBtn,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  });









 if (document.querySelector('.search-bar')) {
  document.querySelector('.search-bar').addEventListener('input', function (event) {
    event.preventDefault();
    let query = this.value.toLowerCase().trim(); // Search query in lowercase and trimmed
    let sections = document.querySelectorAll('.section-collection-list'); // Select all sections

    sections.forEach(function (section) {
      let products = section.querySelectorAll('.grid__item'); // Products inside each section
      let hasVisibleProduct = false; // Flag to check if section has any visible product

      products.forEach(function (product) {
        let productName = product.querySelector('.full-unstyled-link').textContent.toLowerCase(); // Product name

        // Check if the product name includes the search query
        if (productName.includes(query)) {
          product.style.display = 'block'; // Show the matching product
          hasVisibleProduct = true; // Mark section as having at least one visible product
        } else {
          product.style.display = 'none'; // Hide the non-matching product
        }
      });

      // If no visible product in this section, hide the section; otherwise, show it
      if (hasVisibleProduct) {
        section.style.display = 'block';
      } else {
        section.style.display = 'none';
      }
    });
  });
}







  

});
